





























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { DirectiveBinding } from 'vue/types/options'
import { VNode } from 'vue/types/umd'

import { BaseButton, ButtonTypes } from '../../../../NewMessageEditors/NewMessageEditorWithMedia/ButtonsConstructor/Buttons/types'
import MessageEditorModelButtonsFactory
  from '../../../../NewMessageEditors/NewMessageEditorWithMedia/ButtonsConstructor/logic/MessageEditorModelButtonsFactory'
import CustomEditor from '../../logic/Editor/CustomEditor'
import CustomNode from '../../logic/Nodes/CustomNode'
import Socket from '../Socket/OutputSocket.vue'
import ButtonView from './ButtonView.vue'

@Component({
  components: {
    Socket,
    ButtonView,
  },
  data() {
    return {
      ButtonTypes
    }
  },
  directives: {
    socket: {
      bind(el: HTMLElement, binding: DirectiveBinding, vnode: VNode) {
        (vnode.context as any).bindSocket(el, binding.arg, binding.value);
      },
      update(el: HTMLElement, binding: DirectiveBinding, vnode: VNode) {
        (vnode.context as any).bindSocket(el, binding.arg, binding.value);
      }
    },
  }
})
export default class RowButtonView extends Vue {
  @Prop() buttons!: Array<Array<BaseButton>>

  @Prop() node!: CustomNode

  @Prop() bindSocket!: DirectiveBinding

  @Prop() editor!: CustomEditor

  /** Проп для визуального выделения кнопок (моргания), опциональный */
  @Prop({ type: Array, default: () => [] }) selectedButtons!: Array<number>

  isButton(button: BaseButton, type: ButtonTypes): boolean {
    const constructor = MessageEditorModelButtonsFactory.ModelsFactories.find(v => v.name === type)

    if (constructor && constructor.value) {
      return button instanceof constructor.value
    }

    return false
  }
}
